import React, { useEffect, useState } from 'react';
import clinicService from '../../../../../services/clinic.service';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import Loading from '../../../../common/Loading';

const AssetForm = ({ assets, getAssets, onSaved }) => {
    const { register, handleSubmit } = useForm({
        defaultValues: assets,
    });

    const onSubmit = (data) => {
        clinicService
            .saveAssets(data.clinicId, data)
            .then(() => {
                onSaved();
                getAssets();
                toast.success('Updated Assets', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            })
            .catch(() => {
                toast.error('Error while updating', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            });
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <label htmlFor="directory" className="notifications-form-label">
                Directory Name
            </label>
            <input
                type="text"
                id="directory"
                placeholder="Directory Name"
                {...register('directory')}
                className="form-control form-control-sm"
            />
            <div className="d-flex mt-3 pt-2 border-top">
                <button className="btn btn-sm btn-success" type="submit">
                    <i className="bi bi-floppy me-1"></i>
                    Save
                </button>
            </div>
        </form>
    );
};

function AssetsCard() {
    const { clinicId } = useParams();
    const [assets, setAssets] = useState(null);
    const [edit, setEdit] = useState(false);
    const [loading, setLoading] = useState(false);

    const getAssets = () => {
        setLoading(true);
        clinicService
            .getAssets(clinicId)
            .then((res) => {
                setAssets(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };

    useEffect(() => {
        getAssets();
    }, [clinicId]);

    return (
        <div className="notifications-panel">
            <div className="notifications-panel__header justify-content-between">
                <span className="d-flex align-items-center gap-2">
                    <i className="bi bi-folder"></i>
                    Assets Directory
                </span>
                {assets && (
                    <button
                        type="button"
                        className={`btn btn-sm ${edit ? 'btn-outline-danger' : 'btn-outline-primary'}`}
                        onClick={() => setEdit(!edit)}
                    >
                        <i className={`bi ${edit ? 'bi-x' : 'bi-pencil-square'}`}></i>
                        {edit ? ' Cancel' : ' Edit'}
                    </button>
                )}
            </div>
            <div className="notifications-panel__body">
                {loading ? (
                    <Loading />
                ) : assets ? (
                    edit ? (
                        <AssetForm
                            assets={assets}
                            getAssets={getAssets}
                            onSaved={() => setEdit(false)}
                        />
                    ) : (
                        <div className="notifications-info-value">{assets.directory || '—'}</div>
                    )
                ) : (
                    <div className="notifications-empty-state py-3">
                        <i className="bi bi-folder"></i>
                        No assets directory configured.
                    </div>
                )}
            </div>
        </div>
    );
}

export default AssetsCard;
